import React, { forwardRef, useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DashboardLayout } from '../../Layout/DashboardLayout'
import CustomTable from '../../Components/CustomTable'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faEllipsisV, faTimes } from '@fortawesome/free-solid-svg-icons'
import BASEURL from '../../Config/global';
import axios from 'axios';
import { Dropdown } from 'react-bootstrap'
import { questionModal, successModal } from '../../Components/CustomModal';
import CustomLoader from '../../Components/CustomLoader';
import './style.css';
import CustomFilters from '../../Components/CustomFilters'
import CustomPagination from '../../Components/CustomPagination'
import { useDebounce } from 'use-debounce'
import { disabledButtonByPermission } from '../../Components/Permissions'
import { PermissionsContext } from '../../Layout/PermissionContext'
import { patchRequest } from '../../Util/requests'
import { getAccessToken } from '../../Util/token'
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { getQuestionModalTitleForSorting, sortingUpdatedSuccessfullyMsg } from '../../Util/common'
import { SCOFA_TABLE_HEADER_KEY } from '../../Components/ScofaApp/ScofaAppData'
import ScofaAppColumn from '../../Components/ScofaApp/ScofaAppColumn'

const PublishFeatureMix = () => {
    const { permissions } = useContext(PermissionsContext)
    const navigate = useNavigate()
    const scofaColumnRef = useRef();

    const [config, setConfig] = useState({ error: false, msg: '', value: '', loader: false });
    const [soundMixList, setSoundMixList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [enteries, setEnteries] = useState(10);
    const [offset, setOffset] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [isListPositionUpdated, setIsListPositionUpdated] = useState(false);
    const [filterSearchValue, setFilterSearchValue] = useState("");
    const [listDropdownValue, setListDropdownValue] = useState("all");
    const [selectedLanguage, setSelectedLanguage] = useState("english");

    const [debouncedFilterSearchValues] = useDebounce(filterSearchValue, 2000)

    useEffect(() => {
        getData()
    }, [offset, debouncedFilterSearchValues, enteries, listDropdownValue, selectedLanguage])

    const modulesWisePermission = (condition) => {
        if (!permissions) {
            return 'd-none'
        }
        return disabledButtonByPermission(permissions, condition)
    }
    const header = [
        SCOFA_TABLE_HEADER_KEY,
        {
            key: "id",
            title: "Mix ID",
        },
        {
            key: "Featured",
            title: "Featured",
        },
        {
            key: "title",
            title: "Title",
        },
        {
            key: "category",
            title: "category",
        },
        {
            key: "SubCategory",
            title: "Sub Category",
        },
        {
            key: "underagecontent",
            title: "Under age content",
        },
        {
            key: "Action",
            title: "Action",
        },
    ];

    const onSortEnd = (result) => {
        if (!result.destination) return;

        const oldIndex = result.source.index;
        const newIndex = result.destination.index;

        if (oldIndex === newIndex) return;

        const reorderedList = Array.from(soundMixList);
        const [movedItem] = reorderedList.splice(oldIndex, 1);
        reorderedList.splice(newIndex, 0, movedItem);

        setIsListPositionUpdated(true);
        setSoundMixList(reorderedList);
    };

    const getData = async () => {
        // fetch data from API with email
        // update state with fetched data
        try {
            setConfig({ ...config, loader: true, error: false });
            const languageParam = selectedLanguage === "spanish" ? "&language=spanish" : "";
            const response = await axios.get(`${BASEURL}/api/sounds/set-mixer-category/?limit=${enteries}&offset=${offset}&search=${debouncedFilterSearchValues}&featured=${listDropdownValue == 'featured' ? true : ''}${languageParam}`);
            setConfig({ ...config, loader: false });
            if (response.data.count === 0 && response.data.data.length === 0) {
                setSoundMixList([])
                setConfig({ ...config, error: true, msg: "No Record Found" });
            } else {
                setSoundMixList(response?.data?.data)
                setTotalCount(response?.data?.count)
            }
            setIsListPositionUpdated(false);
        } catch (error) {
            setSoundMixList([])
            setConfig({ ...config, error: true, msg: "No Record Found", loader: false });
        }
    }

    // Navigate to edit route
    const handleEdit = (item) => {
        navigate(`/publish-featured-mix/edit/${item.id}`)
    }

    const updateMixSortingPositionConfirmation = async () => {
        // fetch data from API with email
        // update state with fetched data

        try {
            questionModal.fire({
                title: getQuestionModalTitleForSorting(listDropdownValue, 'Mix'),
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.isConfirmed) {
                    setLoader(true);
                    updateMixSortingPosition();
                }
            });
        } catch (error) {
            console.log(error)
            // setCategoryModalConfig({ ...config, msg: error.message, loader: false });
        }
    }

    const updateMixSortingPosition = async () => {
        // fetch data from API with email
        // update state with fetched data
        try {
            let body = {
                user_id: soundMixList[0]['user'],
                data: soundMixList?.map((item, index) => ({ mixid: item.id, position: index + 1 }))
            }
            console.log("body", body)
            // setCategoryModalConfig({ ...config, loader: true });
            const url = listDropdownValue === 'all' ? '/api/sounds/update-mix-position/' : `/api/sounds/update-featured-mix-position/`;
            // https://backend.dev.relax.scofa.com/api/sounds/update_mix_position/
            const response = await patchRequest(url, body, null)
            setLoader(false);
            if (!response.data.error && response.data.status === 200) {
                successModal.fire({
                    title: sortingUpdatedSuccessfullyMsg(listDropdownValue, 'Mix'),
                    confirmButtonText: "Continue",
                });
                setConfig({ ...config, loader: false, value: '' });
                setIsListPositionUpdated(false);
            }
        } catch (error) {
            setLoader(false);
            setConfig({ ...config, loader: false });
            console.log(error);
            // setCategoryModalConfig({ ...config, msg: error.message, loader: false });
        }
    }

    const handleDeleteFeatureMix = (deleteId) => {
        questionModal.fire({
            title: `Do you want to hide this mix from list?`,
            confirmButtonText: "Hide",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoader(true);
                await deleteFeatureMix(deleteId);
            }
        });
    }
    const deleteFeatureMix = async (deleteId) => {
        try {
            let token = getAccessToken()
            let data = JSON.stringify({
                "mixer_id": deleteId
            });

            let config = {
                method: 'delete',
                url: `${BASEURL}/api/sounds/set-mixer-category/`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + token,
                },
                data: data
            };

            const response = await axios.request(config)

            setLoader(false);
            if (!response.data.error && response.data.status === 200) {
                successModal.fire({
                    text: `Mixture deactivated successfully`,
                    confirmButtonText: "Continue",
                });
                setConfig({ ...config, loader: false });
                setSoundMixList(soundMixList.filter(f => f.id !== deleteId))

            }
        } catch (error) {
            setLoader(false);
            setConfig({ ...config, error: true, msg: error.message });
            console.log(error);
        }
        // console.log(response.data)
    }
    const handleChangeEntries = (no) => {
        setOffset(0)
        setEnteries(no)
    }
    return (
        <>

            <DashboardLayout>
                <div className='container-fluid'>
                    {/* TOP ROW / SEARCH BAR */}
                    <div className="row mb-3">
                        <div className="col-lg-4 mb-2">
                            <h2 className="mainTitle">Publish Featured Mixes</h2>
                        </div>
                        <div className="col-8 text-end">
                            <button onClick={() => scofaColumnRef.current.handleScofaFlag()} className="customButton primaryButton me-3">
                                Update Scofa Tracks
                            </button>
                            <button type="button"
                                disabled={soundMixList.length > 0 && isListPositionUpdated ? false : true}
                                className={`customButton ${soundMixList.length > 0 && isListPositionUpdated ? 'primaryButton' : ''}`}
                                onClick={updateMixSortingPositionConfirmation}>
                                Update Ordering
                            </button>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <CustomFilters
                                enteries={enteries}
                                totalCount={totalCount}
                                entriesFilter={true}
                                setEnteries={handleChangeEntries}
                                filterSearch={true}
                                filterSearchValue={filterSearchValue}
                                setFilterSearchValue={setFilterSearchValue}
                                listDropdown={true}
                                listDropdownValue={listDropdownValue}
                                setListDropdownValue={setListDropdownValue}
                            // languageFilter={true}
                            // languageValue={selectedLanguage}
                            // setLanguageValue={setSelectedLanguage}
                            />
                        </div>
                    </div>

                    <DragDropContext onDragEnd={onSortEnd}>
                        <Droppable droppableId="soundMix-list">
                            {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                    <CustomTable headers={header}>
                                        <tbody>
                                            {(!config.loader && soundMixList.length > 0) ? (
                                                soundMixList.map((item, index) => (
                                                    <Draggable
                                                        draggableId={`mix-${item.id}`}
                                                        index={index}
                                                        key={item.id}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <tr
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={`my-1 ${snapshot.isDragging ? "dragging" : ""}`}
                                                            >

                                                                <ScofaAppColumn ref={scofaColumnRef} item={item} category="soundsmixture" />



                                                                <td>{item.id}</td>

                                                                <td>
                                                                    <div className='mt-2'>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="featured"
                                                                            key={`featured-${item.id}`}
                                                                            checked={item.is_featured}
                                                                        // onChange={...}
                                                                        />
                                                                    </div>
                                                                </td>

                                                                <td>{item.title}</td>
                                                                <td>{item.parent_category_name}</td>
                                                                <td>{item.sub_category_name}</td>
                                                                <td>{item.child_content ? "YES" : "NO"}</td>

                                                                <td width={150}>
                                                                    <Dropdown className="tableDropdown">
                                                                        <Dropdown.Toggle
                                                                            variant="transparent"
                                                                            className="notButton classicToggle"
                                                                        >
                                                                            <FontAwesomeIcon icon={faEllipsisV} />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu
                                                                            align="end"
                                                                            className="tableDropdownMenu"
                                                                        >
                                                                            <button
                                                                                className={`tableAction ${modulesWisePermission('can_edit')}`}
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    handleEdit(item);
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon
                                                                                    icon={faEdit}
                                                                                    className="tableActionIcon"
                                                                                />
                                                                                Edit
                                                                            </button>
                                                                            <button
                                                                                className={`tableAction ${modulesWisePermission('can_delete')}`}
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    handleDeleteFeatureMix(item.id);
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon
                                                                                    icon={faTimes}
                                                                                    className="tableActionIcon"
                                                                                />
                                                                                Hide
                                                                            </button>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Draggable>
                                                ))
                                            ) : (
                                                <tr>
                                                    {config.error && <td colSpan="7" className="text-center">{config.msg}</td>}
                                                    {config.loader && (
                                                        <td colSpan="7" className="text-center">
                                                            <div className="spinner-border" role="status"></div>
                                                        </td>
                                                    )}
                                                </tr>
                                            )}
                                            {provided.placeholder}
                                        </tbody>
                                    </CustomTable>
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <CustomPagination
                            enteries={enteries}
                            totalCount={totalCount}
                            setCurrentPage={setOffset}
                            currentPage={offset}
                        />
                    </div>
                </div>
            </DashboardLayout>

            {/* Loader */}
            {loader && <div className='featured-loader'><CustomLoader /></div>}
        </>
    )
}

export default PublishFeatureMix